// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3B2AM","fileBtn":"File_fileBtn__2P6A-","closeBtn":"File_closeBtn__jUDef","fileSelected":"File_fileSelected__hxfyg","disabled":"File_disabled__3SmSS"};